import React from 'react';
import { KitchenShiftSingleType } from 'models/kitchen-roster.model';
import { ROSTER_SHIFT } from 'utils/enum';

type Props = {
  shift: ROSTER_SHIFT;
  data: KitchenShiftSingleType[];
};

const RosterCard = (props: Props) => {
  const { shift, data } = props;

  if (!data) return null;
  return (
    <div className='w-full flex flex-col gap-4 p-[10px] border border-[#ECEDEE] rounded-[20px]'>
      <div className='flex flex-col bg-[#F5F5F5] rounded-xl'>
        <h3 className='text-[#1A1A1A] text-center font-medium tracking-[10px] uppercase p-4 border-b border-[#E8E8E8]'>
          {shift} Shift
        </h3>
        <div className='flex items-center gap-2 px-4 py-3'>
          <p className='w-1/2 text-[#595959] font-medium'>Department</p>
          <p className='w-1/2 text-[#595959] font-medium'>Staff</p>
        </div>
      </div>
      <ul className='flex flex-col gap-4'>
        {data?.map((dept, idx) => (
          <li
            key={idx}
            className='flex items-start gap-2 px-4 pb-4 border-b border-[#EBEBEB] last:border-b-0'>
            <p className='w-1/2 text-[#1A1A1A] font-medium'>{dept?.department}</p>
            <p className='w-1/2 text-[#1A1A1A] font-medium'>
              {dept.staff.map((staff) => staff.name).join(', ')}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RosterCard;
